import Store                from "Dashboard/Core/Store";
import DateTime             from "Dashboard/Utils/DateTime";
import Utils                from "Dashboard/Utils/Utils";
import { Billboard }        from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    statuses  : [],
    filters   : {
        search   : "",
        fromDate : "",
        toDate   : "",
    },
    sort      : {
        orderBy  : "publishTime",
        orderAsc : 0,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "BILLBOARD_LOADING" });
    },

    /**
     * Fetches the Billboard Entry List
     * @param {Function} dispatch
     * @param {Object=}  filters
     * @param {Object=}  sort
     * @returns {Promise}
     */
    async fetchList(dispatch, filters = {}, sort = {}) {
        const data   = await Billboard.getAll({ ...filters, ...sort });
        data.filters = filters;
        data.sort    = sort;
        dispatch({ type : "BILLBOARD_LIST", data });
    },

    /**
     * Fetches a single Billboard Entry
     * @param {Function} dispatch
     * @param {Number}   billboardID
     * @returns {Promise}
     */
    async fetchElem(dispatch, billboardID) {
        const data = await Billboard.getOne({ billboardID });
        dispatch({ type : "BILLBOARD_ELEM", data });
        return data;
    },

    /**
     * Fetches the Billboard Entry Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await Billboard.getEditData();
        dispatch({ type : "BILLBOARD_EDIT", data });
    },

    /**
     * Edits/Creates a Billboard Entry
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return Billboard.edit(data);
    },

    /**
     * Deletes the Billboard Entry
     * @param {Function} dispatch
     * @param {Number}   billboardID
     * @returns {Promise}
     */
    deleteElem(dispatch, billboardID) {
        return Billboard.delete({ billboardID });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.publishTimeDate = DateTime.formatDate(elem.publishTime, "dashes");
    elem.publishDate     = DateTime.formatDate(elem.publishTime, "dashesReverse");
    elem.showBeforeText  = Utils.toYesNo(elem.showBefore);
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "BILLBOARD_LIST", "BILLBOARD_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "BILLBOARD_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "BILLBOARD_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : Utils.parseList(action.data.list, parseElem),
            total     : action.data.total,
            filters   : action.data.filters,
            sort      : action.data.sort,
        };

    case "BILLBOARD_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : parseElem(action.data.elem),
            statuses  : action.data.statuses,
        };

    case "BILLBOARD_EDIT":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            statuses  : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
